import { MISSION_PREFERENCES_OPTALL, CPM_NO, CPM_YES } from "constants/cpm";
import { consentOptions } from "constants/PreferencesConst";
import customFetch from "utils/customFetch";

const ENDPOINTS = {
  GET_CONSENTS: "/preferences/consents",
};
const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export function getConsents(email) {
  let encodedEmail = encodeURIComponent(email);
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  return customFetch(
    `${ENDPOINTS.GET_CONSENTS}?email=${encodedEmail}`,
    requestOptions
  );
}

function buildConsentsRequestToSave(formData, missionId, touchpoint) {
  const missionConfig = JSON.parse(sessionStorage.getItem(missionId));
  const consentToSave = {
    mission_code: missionConfig.cpm_mission_code,
    touchpoint: touchpoint,
  };
  if (formData[MISSION_PREFERENCES_OPTALL] === CPM_NO) {
    consentToSave.consents = [];
    // eslint-disable-next-line no-unused-vars
    for (const [i, element] of consentOptions.entries()) {
      consentToSave.consents.push({
        mission_name: element.key,
        consent: formData[element.key] == null ? "N" : formData[element.key],
      });
    }
  } else if (formData[MISSION_PREFERENCES_OPTALL] === CPM_YES) {
    consentToSave.consent = "Y";
  }
  return consentToSave;
}

export const cpmService = {
  getConsents,
  buildConsentsRequestToSave,
};
